var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"single-product-favorite-button",on:{"click":_vm.addToFavorites}},[_c('img',{attrs:{"src":"/images/icons/coeur-orange.png","alt":"Coeur"}}),_vm._v(" "),(_vm.isInFavorites)?_c('span',[_vm._v("Retirer de mes coups de coeur")]):_c('span',[_vm._v("Ajouter à mes coups de coeur")])])
}
var staticRenderFns = []

export { render, staticRenderFns }